const UPDATE_CURRENT_CHAT = '@@chat/UPDATE_CURRENT_CHAT';

// const LOG_OUT = '@@auth/CLEAR_SEARCH'

export default {
	UPDATE_CURRENT_CHAT,
	// CLEAR_SEARCH
};


